export const clickOutside = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      // Check if the click was outside the element and its children
      if (!(el === event.target || el.contains(event.target))) {
        // Call the provided method
        binding.value(event)
      }
    }

    el.focusOutsideEvent = function (event) {
      // Only trigger if the newly focused element is outside (E.g. when tabbing )
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }

    document.body.addEventListener('click', el.clickOutsideEvent)
    document.body.addEventListener('focusin', el.focusOutsideEvent)
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
    document.body.removeEventListener('focusin', el.focusOutsideEvent)
  }
}
